// Roving tab-index keyboard navigation for a list of tabs/items.
// Handles Arrow keys, Home and End and calls onSelect(nextIndex, moveFocus=true).
//
//   const onKeyDown = useRovingKeyboardNav(count, select, { axis: "vertical" });
//   <button onKeyDown={(e) => onKeyDown(e, index)} />
//
// axis: "vertical" (Up/Down), "horizontal" (Left/Right) or "both".
import { useCallback } from "react";

const NEXT_KEYS = { vertical: ["ArrowDown"], horizontal: ["ArrowRight"], both: ["ArrowDown", "ArrowRight"] };
const PREV_KEYS = { vertical: ["ArrowUp"], horizontal: ["ArrowLeft"], both: ["ArrowUp", "ArrowLeft"] };

export function nextRovingIndex(key, index, count, axis = "both") {
  if (NEXT_KEYS[axis].includes(key)) return (index + 1) % count;
  if (PREV_KEYS[axis].includes(key)) return (index - 1 + count) % count;
  if (key === "Home") return 0;
  if (key === "End") return count - 1;
  return null;
}

export function useRovingKeyboardNav(count, onSelect, { axis = "both" } = {}) {
  return useCallback(
    (event, index) => {
      const next = nextRovingIndex(event.key, index, count, axis);
      if (next === null) return;
      event.preventDefault();
      onSelect(next, true);
    },
    [count, onSelect, axis]
  );
}
